import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { DropzoneComponent, DropzoneComponentConfig, DropzoneComponentHandlers, DropzoneComponentProps } from 'react-dropzone-component';
import * as Dropzone from 'dropzone';
import { Tabs, Tab } from 'react-bootstrap';
import ReactJson from 'react-json-view';

interface PDFFieldResult {
    success: boolean;
    error: boolean;
    errorMessage: string;
    jsonData: any;
}

export class PDFFields extends React.Component<RouteComponentProps<{}>, PDFFieldResult> {
    private djsConfig: any = {};
    private eventHandler: DropzoneComponentHandlers = {};
    private componentConfig: DropzoneComponentConfig = {};
    private myDropzone: any = null;
    private dataUrl: string = 'api/pdfmerge/getpdffields';
    private dropzone: Dropzone;
    private style: any = {
        'margin-top': '10px',
        'max-height': '350px',
        'min-height': '350px',
        'overflow-y': 'scroll'
    };

    constructor(props: any) {
        super(props);

        this.init = this.init.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleError = this.handleError.bind(this);

        this.state = {
            success: false,
            error: false,
            errorMessage: "",
            jsonData: {}
        }

        this.djsConfig = {
            addRemoveLinks: false,
            acceptedFiles: ".pdf",
            uploadMultiple: false,
            maxFiles: 1,
            autoProcessQueue: true,
            paramName: "pdfform"
        }

        this.componentConfig = {
            showFiletypeIcon: true,
            iconFiletypes: ['.pdf'],
            postUrl: this.dataUrl
        }

        this.eventHandler = {
            success: this.handleSuccess,
            init: this.init,
            error: this.handleError
        }
    }

    private init(passedDropzone: Dropzone) {
        console.log("init called");
        this.dropzone = passedDropzone;
        this.setState({ success: false, error: false });
    }

    private handleSuccess(file: any, response: any) {
        if (response.success == true) {
            this.setState({ success: true, error: false, jsonData: response.data });
        }
        else {
            this.setState({ success: false, error: true, errorMessage: response.message });
        }

        this.dropzone.removeAllFiles(true);
    }

    private handleError(file: any, errorMessage: string) {
        this.setState({ success: false, error: true, errorMessage: errorMessage });
        this.dropzone.removeAllFiles(true);
    }

    public render() {
        return <div>
            <div className="page-header">
                <h3>PDF Fields</h3>
            </div>
            {
                this.state.error ?
                    <div className="row alert alert-danger mt-5">
                        {this.state.errorMessage}
                    </div> : null
            }
            <div className="form-group">
                <label>Select PDF File:</label>
                <DropzoneComponent config={this.componentConfig} eventHandlers={this.eventHandler} djsConfig={this.djsConfig} />
            </div>
            <div className="form-group">
                <label>PDF Data:</label>
                <Tabs defaultActiveKey={1} id="apirequesttabs">
                    <Tab eventKey={1} title="JSON View">
                        <div className="row" style={this.style}>
                            <div className="col-sm-11">
                                <ReactJson src={this.state.jsonData} name="Data" />
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey={2} title="Raw View">
                        <textarea value={JSON.stringify(this.state.jsonData)} className="form-control" rows={11}>
                        </textarea>
                    </Tab>
                </Tabs>
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/PDFFields.tsx